import { useTranslation } from "react-i18next";
import DiaryValuesLineChart from "../diary/DiaryValuesLineChart";
import { formatOnlyDateForGui} from "../pages/utils";

const transformSymptomsToDataSets = (symptoms, t) => {
  const dataMap = {};

  symptoms?.forEach((symptom) => {
    const label = symptom?.term;
    const date = formatOnlyDateForGui(symptom?.startDate);

    const dataPoint = {
      x: date,
      y: symptom?.sufferingLevel,
      endDate: symptom?.deactivated === 0 ? "" : symptom?.endDate
    };

    if (!dataMap[label]) {
      dataMap[label] = {
        label: t(label),
        data: [dataPoint],
        connectPoints: false,
      };
    } else {
      dataMap[label].data?.push(dataPoint);
    }
  });

  return Object.values(dataMap);
};

const SymptomsLineChart = ({
  symptoms,
  patientId,
  onCloseDialog,
  showDialog,
}) => {
  const { t } = useTranslation();
  const values = transformSymptomsToDataSets(symptoms, t);

  return (
    <DiaryValuesLineChart
      header={t("symptoms_line_chart")}
      values={values}
      showDialog={showDialog}
      onCloseDialog={onCloseDialog}
      maxYScale={5}
      patientId={patientId}
    />
  );
};

export default SymptomsLineChart;
